type BlobShapeProps = {
  uid: string
}

const BLOB_PATH =
  'M419.457 -164.007C486.426 -181.951 555.261 -142.209 573.206 -75.2404C591.15 -8.27174 551.408 60.5637 484.439 78.5079C459.829 85.1021 434.811 98.4979 410.415 116.909C388.974 139.777 383.105 170.885 391.211 213.009C436.92 271.747 506.59 311.302 587.047 316.817C640.478 318.988 688.599 355.414 703.169 409.789C721.113 476.758 681.371 545.593 614.402 563.537C560.004 578.113 504.375 554.627 475.79 509.403C430.784 442.516 361.709 401.976 288.004 391.765C247.473 405.807 223.467 426.444 214.384 456.445C210.637 486.778 211.545 515.142 218.139 539.753C236.083 606.721 196.341 675.557 129.373 693.501C62.4041 711.445 -6.43136 671.703 -24.3756 604.734C-33.3539 571.227 -27.8918 537.251 -11.8023 509.417C6.54142 477.608 0.955402 456.818 -30.8675 438.445C-58.6905 422.382 -80.3851 395.704 -89.3572 362.219C-107.301 295.251 -67.5592 226.415 -0.590619 208.471C85.1513 185.497 111.15 140.465 88.176 54.7229C70.2318 -12.2457 109.974 -81.0811 176.943 -99.0253C210.427 -107.997 244.378 -102.548 272.201 -86.4847C304.024 -68.1117 324.821 -73.669 343.197 -105.46C359.257 -133.311 385.95 -155.029 419.457 -164.007Z'

const NOISE_TABLE_1 =
  '1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0'

const NOISE_TABLE_2 =
  '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1'

export const BlobShape = ({uid}: BlobShapeProps) => (
  <svg
    className="overflow-visible"
    fill="none"
    height="757"
    viewBox="0 0 767 757"
    width="767"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter={`url(#filter0_fn_${uid})`}>
      <path clipRule="evenodd" d={BLOB_PATH} fill={`url(#paint0_linear_${uid})`} fillRule="evenodd" />
      <path clipRule="evenodd" d={BLOB_PATH} fill={`url(#paint1_radial_${uid})`} fillOpacity="0.3" fillRule="evenodd" />
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="984.165"
        id={`filter0_fn_${uid}`}
        width="919.184"
        x="-152.686"
        y="-227.336"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
        <feGaussianBlur result={`effect1_foregroundBlur_${uid}`} stdDeviation="29.5101" />
        <feTurbulence
          baseFrequency="1.2286956310272217 1.2286956310272217"
          numOctaves="3"
          result="noise"
          seed="2512"
          stitchTiles="stitch"
          type="fractalNoise"
        />
        <feColorMatrix in="noise" result="alphaNoise" type="luminanceToAlpha" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA tableValues={NOISE_TABLE_1} type="discrete" />
        </feComponentTransfer>
        <feComposite in="coloredNoise1" in2={`effect1_foregroundBlur_${uid}`} operator="in" result="noise1Clipped" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise2">
          <feFuncA tableValues={NOISE_TABLE_2} type="discrete" />
        </feComponentTransfer>
        <feComposite in="coloredNoise2" in2={`effect1_foregroundBlur_${uid}`} operator="in" result="noise2Clipped" />
        <feFlood floodColor="rgba(0, 36, 20, 0.5)" result="color1Flood" />
        <feComposite in="color1Flood" in2="noise1Clipped" operator="in" result="color1" />
        <feFlood floodColor="rgba(255, 255, 255, 0.5)" result="color2Flood" />
        <feComposite in="color2Flood" in2="noise2Clipped" operator="in" result="color2" />
        <feMerge result={`effect2_noise_${uid}`}>
          <feMergeNode in={`effect1_foregroundBlur_${uid}`} />
          <feMergeNode in="color1" />
          <feMergeNode in="color2" />
        </feMerge>
      </filter>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id={`paint0_linear_${uid}`}
        x1="-93.6494"
        x2="592.351"
        y1="-5.99998"
        y2="228"
      >
        <stop stopColor="#B9FF3F" />
        <stop offset="0.724438" stopColor="#B9FF3F" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="matrix(284 176 -114.071 304.423 -19.6494 102)"
        gradientUnits="userSpaceOnUse"
        id={`paint1_radial_${uid}`}
        r="1"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)
